<template>
  <div>
    <div class="staff">
      <div class="left-top">
        <span style="font-size: 18px; font-weight: 400; color: #333">
          政务小程序管理
        </span>
        <el-divider></el-divider>
        <el-input
          v-model="Params.AppName"
          placeholder="小程序名称"
          maxlength="20"
          style="width: 200px; margin-right: 10px;"
          clearable
        ></el-input>
        <el-select v-model="SourceType" placeholder="请选择地域" @change="searchRegion" style="margin-right: 10px;">
          <el-option v-for="item in regionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input v-show="SourceType == 1"  v-model="RegionName" placeholder="请选择省份" id="citySelect_p" style="width: 200px; margin-right: 10px;"/>
        <el-input v-show="SourceType == 2" v-model="RegionName" placeholder="请选择城市" id="citySelect2" style="width: 200px; margin-right: 10px;"/>
        <el-button type="primary" @click="queryGovApp">查询</el-button>
        <el-button type="primary" @click="exportGovAppList">导出</el-button>
        <el-button type="primary" @click="editData(false)">添加小程序</el-button>
        <el-button type="primary" @click="exportTemplate">下载导入模板</el-button>
        <el-upload
          :action="this.$api.ImportGovAppList"
          :headers="headers"
          :show-file-list="false"
          accept=".xlsx,.xls"
          :on-success="handleImportSuccess"
          :on-error="handleImportError"
          style="display: inline-block;"
        >
          <el-button type="primary">导入Excel</el-button>
        </el-upload>
      </div>
      <el-table :data="GovAppList" row-key="Id" style="width: 100%">
        <el-table-column fixed label="序号" width="60" type="index" align="center" />
        <el-table-column label="排序" width="80" prop="SortOrder" align="center">
          <template slot-scope="scope">
            <span style="font-weight: 700">{{ scope.row.SortOrder }}</span>
          </template>
        </el-table-column>
        <el-table-column label="小程序名称" width="150" prop="AppName" align="center" />
        <el-table-column label="小程序id" width="180" prop="AppId" align="center" />
        <el-table-column label="小程序原始id" width="180" prop="OriginalId" align="center" />
        <el-table-column label="小程序路径" width="180" prop="AppPath" align="center" />
        <el-table-column label="封面图片" width="100" prop="AppLogo" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.AppLogo" alt="封面" style="width:40px;height:40px;object-fit:cover;" />
          </template>
        </el-table-column>
        <el-table-column label="地域" width="100" prop="RegionName" align="center" />
        <el-table-column label="是否在前端显示" width="120" prop="IsEnable" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.IsEnable"
              :active-value="true"
              :inactive-value="false"
              active-text="是"
              inactive-text="否"
              @change="toggleEnable(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="添加时间" width="160" prop="AddTime" align="center" />
        <el-table-column fixed="right" width="200" label="操作" align="center">
          <template slot-scope="scope">
            <span class="backSpan" @click="editData(true, scope.row)" style="color: #409eff">
              编辑
            </span>
            <span class="backSpan" @click="deleteData(scope.row.Id)" style="color: #cc0000">
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="task-list-page" v-if="GovAppList !== ''">
        <el-pagination
          @current-change="OnCurrentPageChanged"
          @size-change="handleSizeChange"
          :current-page="Params.PageIndex"
          :page-sizes="[10, 20, 30, 40, 50, 60]"
          layout="prev, pager, next,sizes,jumper,total"
          :page-size="Params.PageSize"
          background
          :total="Params.TotalCount"
        >
        </el-pagination>
      </div>

      <!-- 新增/编辑弹窗 -->
      <el-dialog class="item-dialog" :title="isEdit ? '编辑' : '新增'" :visible.sync="showDialog" fullscreen
        :close-on-click-modal="false" :close-on-press-escape="false">
        <add-or-edit v-if="showDialog" :is-edit="isEdit" :form-data="curData" @success="dialogSuccess"
          @close="dialogClose" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { MyVcity, MyVcity_Provence } from "@/utils/chooseAllCity"; //城市/省份选择框
import addOrEdit from "./edit.vue"; //新增/编辑弹窗组件
export default {
  components:{
    addOrEdit
  },
  data() {
    return {
      GovAppList:[], //分页数据列表
      Params: {
        pageIndex: 1,
        pageSize: 10,
        AppName: '', // 小程序名称查询条件
        TotalCount: 5,   //查询结果总条数(与查询条件无关)
        TotalPage: 0,//查询结果总页数(与查询条件无关)
      }, 
      // 地域下拉选项列表
      regionOptions: [ 
        { value: -1, label: '请选择地域' },
        { value: 0, label: '全国' },
        { value: 1, label: '省份' },
        { value: 2, label: '城市' }
      ],
      SourceType: -1, // 地域类型
      RegionName: '', //地域名称

      curData: {}, // 当前编辑的数据
      isEdit: false, // 是否正在编辑
      showDialog: false, // 是否显示新增/编辑弹窗
      headers: {
        Authorization: `Bearer ${this.getCookie("tokenAdmin")}`,
      },
    };
  },
  created() {
    this.queryGovApp();
  },
  computed: {
    QueryParamsWithRegion() {
      return {
        ...this.Params,
        country: this.SourceType == 0 ? "中国" : "",
        province: this.SourceType == 1 ? this.RegionName : "",
        city: this.SourceType == 2 ? this.RegionName : "",
      };
    }
  },
  mounted() {
    new MyVcity.CitySelector({ input: 'citySelect2' });
    new MyVcity_Provence.CitySelector({ input: 'citySelect_p' });
  },
  methods: {
    queryGovApp() {
      this.$get(this.$api.QueryGovAppList, { ...this.QueryParamsWithRegion })
        .then((res) => {
          this.GovAppList = res.Data;
          this.Params.TotalCount = res.TotalNumber;
          this.Params.TotalPage = res.TotalPage;
        }).catch((err) => {
          alert(err)
          console.log(err);
        });
    },
    searchRegion(value) {
      this.RegionName = ''
    },
    //获取分页
    OnCurrentPageChanged(val) {
      this.Params.pageIndex = val;
      console.log(this.Params.PageIndex);
      this.queryGovApp();
    },
    handleSizeChange(val) {
      this.Params.pageSize = val;
      console.log(val);
      this.queryGovApp();
    },

    //新增/编辑小程序
    editData(isEdit, row = {}){
      if (isEdit) {
        this.curData = row;
      }
      this.isEdit = isEdit;
      this.showDialog = true;
    },
    //新增/编辑成功回调
    dialogSuccess() {
      this.queryGovApp();
      this.dialogClose();
    },
    //关闭新增/编辑弹窗
    dialogClose() {
      this.showDialog = false;
    },

    //删除小程序数据
    async deleteData(id) {
      this.showDeleteConfirm(id);
    },
    async showDeleteConfirm(id) {
      this.$confirm('确定要删除当前数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async () => {
        await this.handleDelete(id);
      }).catch(() => {
          this.$message({type: 'info',message: '已取消删除' });
      });
    },
    async handleDelete(id) {
      try {
        let { IsSuccess, Message } =await this.$post(this.$api.DeleteGovApp, {Ids:[id]}); 
        if(IsSuccess){
          this.$message.success(`${Message}`);
          this.queryGovApp();
        }else{
          this.$message.error(`${Message}`);
        }
      } catch (error) {
        this.$message({type: 'error',message: '删除过程中发生错误，请稍后再试。' });
      }
    },

    //切换启用状态
    toggleEnable(row) {
      this.$post(this.$api.SetGovAppIsEnable, { Ids:[row.Id], IsEnable: row.IsEnable }).
        then(res => {
          if (res.IsSuccess) {
            this.$message.success(res.Message);
            this.queryGovApp();
          } else {
            this.$message.error(res.Message || '切换失败');
          }
        }).catch(() => {
          this.$message.error('切换失败');
          this.queryGovApp();
        });
    },

    //通用下载方法
    async commonDownload(url, defaultFileName) {
      const res = await this.$download(url, {});
      if (res.data.type === "application/json") {
        const text = await res.data.text();
        const json = JSON.parse(text);
        this.$message.error(json.PromptMsg || "下载失败");
        return;
      }
      let fileName = defaultFileName;
      const disposition = res.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(/filename\*=UTF-8''(.+)/);
        if (match) {
          fileName = decodeURIComponent(match[1]);
        }
      }
      const blob = new Blob([res.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    },

    //导出小程序列表
    async exportGovAppList() {
      const query = new URLSearchParams(this.QueryParamsWithRegion).toString();
      const url = `${this.$api.ExportGovAppList}?${query}`;
      await this.commonDownload(url, "政务小程序列表.xlsx");
    },
    async exportTemplate(){
      const url = `${this.$api.DownloadGovAppTemplate}`;
      await this.commonDownload(url, "导入模板.xlsx");
    },

    //导入错误回调
    handleImportError(err) {
      this.$message.error("导入失败，请稍后再试");
      console.error(err);
    },
    //导入成功回调
    handleImportSuccess(response) {
      if (response.IsSuccess) {
        this.$message.success(response.Message || "导入成功");
        this.queryGovApp();
      } else {
        this.$message.error(response.Message || "导入失败");
      }
    },
    getCookie(name) {
      var matches = document.cookie.match(
        new RegExp("(?:^|; )" + name + "=([^;]*)")
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
  }
};
</script>

<style src="../../../assets/css/cityBox.css"></style>
<style lang="stylus" scoped>
/deep/.is-center.is-leaf {
  background: #e6e6e6;
  color: #303133;
}

/deep/.has-gutter tr {
  th {
    background: #e6e6e6;
    color: #303133;
  }

  td {
    text-align: center;
  }
}

.staff {
  background: #fff;
  padding: 10px 10px;
  border-radius: 10px;

  .backSpan {
    margin-right: 20px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }

  .left-top {
    margin-bottom: 10px;

    .el-divider--horizontal {
      margin: 10px 0;
    }

    button {
      margin-left: 10px;
    }
  }

  .el-table .cell span {
    overflow: hidden; /* 超出部分隐藏 */
    white-space: nowrap; /* 不换行 */
    text-overflow: ellipsis; /* 超出部分文字以...显示 */
  }

  .task-list-page {
    margin-top: 10px;
  }
}
</style>
